export default {
  data() {
    return {
      infiniteScroll: {
        page: 1,
        busy: false,
        noMore: false,
        container: null,
        distance: 50,
        initialized: false,
        lastScrollTime: 0,
        loading: false,
        disable: false,
      }
    };
  },
  computed: {
    scrollContainer() {
      return this.infiniteScroll.container;
    },
  },
  methods: {
    async loadMoreWrapper() {
      if (this.infiniteScroll.busy || this.infiniteScroll.noMore || this.infiniteScroll.disable) return;
      this.infiniteScroll.busy = true;
      try {
        const hasMore = await this.loadMore(this.infiniteScroll.page);
        if (hasMore === false) {
          this.infiniteScroll.noMore = true;
        } else {
          this.infiniteScroll.page++;
        }
      } catch (error) {
        this.$emit('infinite-scroll-error', error);
      } finally {
        this.infiniteScroll.busy = false;
        this.infiniteScroll.loading = false;
      }
    },
    getScrollPosition() {
      const el = this.scrollContainer;
      if (!el) {
        return null;
      }
      if (el === window) {
        return {
          scrollTop: window.pageYOffset || document.documentElement.scrollTop,
          clientHeight: window.innerHeight,
          scrollHeight: Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
          )
        };
      }

      return {
        scrollTop: el.scrollTop,
        clientHeight: el.clientHeight,
        scrollHeight: el.scrollHeight
      };
    },
    onScrollHandler() {
      if (!this.infiniteScroll.disable && this.scrollContainer) {
        const now = Date.now();
        if (now - this.infiniteScroll.lastScrollTime < 200) return;
        this.infiniteScroll.lastScrollTime = now;

        if (this.infiniteScroll.busy || this.infiniteScroll.noMore) return;
        const scrollPosition = this.getScrollPosition();
        if (scrollPosition && scrollPosition.scrollTop + scrollPosition.clientHeight >= scrollPosition.scrollHeight - this.infiniteScroll.distance) {
          this.infiniteScroll.loading = true;
          this.loadMoreWrapper();
        }
      }
    },
    validateContainer() {
      if (this.infiniteScroll.container && !(this.infiniteScroll.container instanceof HTMLElement)) {
        this.infiniteScroll.container = null;
      }
    },
    checkContainerVisibility() {
      const el = this.scrollContainer;
      if (!el) {
        this.infiniteScroll.disable = true;
        return false;
      }

      const style = window.getComputedStyle(el);
      const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      this.infiniteScroll.disable = !isVisible;
      return isVisible;
    },
    attachScrollListener() {
      this.validateContainer();
      this.checkContainerVisibility();
      if (this.scrollContainer && !this.infiniteScroll.disable) {
        this.scrollContainer.addEventListener('scroll', this.onScrollHandler);
      }
    },
    detachScrollListener() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.onScrollHandler);
      }
    },
    resetInfiniteScroll() {
      this.infiniteScroll.page = 1;
      this.infiniteScroll.busy = false;
      this.infiniteScroll.noMore = false;
      this.infiniteScroll.disable = false;
    },
    triggerLoadMore() {
      if (!this.infiniteScroll.disable && this.scrollContainer) {
        this.infiniteScroll.loading = true;
        this.loadMoreWrapper();
      }
    }
  },
  watch: {
    'infiniteScroll.container': {
      handler() {
        if (this.infiniteScroll.initialized) {
          this.detachScrollListener();
          this.attachScrollListener();
        }
      },
      deep: false
    }
  },
  mounted() {
    this.validateContainer();
    this.attachScrollListener();
    this.infiniteScroll.initialized = true;
    this.$nextTick(() => {
      if (!this.infiniteScroll.disable && this.scrollContainer) {
        this.infiniteScroll.loading = true;
        this.loadMoreWrapper();
      }
    });
  },
  beforeDestroy() {
    this.detachScrollListener();
  },
  activated() {
    if (this.infiniteScroll.initialized) {
      this.attachScrollListener();
    }
  },
  deactivated() {
    this.detachScrollListener();
  },
};
